export default __webpack_public_path__ + "static/media/strawberry.dcd8d6cc.png";